import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://quantumtrades.com.br:8080";

const api = axios.create({
  baseURL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
